'use strict';

const { hydrate } = require('@grpn/hydration');

const Link = require('./link');

module.exports = hydrate('Link', Link);
